import {
  ComboBox as FComboBox,
  IComboBoxProps as FIComboBoxProps,
  IComboBoxStyles,
  IIconStyles,
} from '@fluentui/react';
import { forwardRef, Ref } from 'react';

import { IComponent, IconName, IStyleFunctionOrObject } from '../../models/components.models';
import { Sizes } from '../../themes/styles';
import { iconStylesCaretDown, iconStylesDarkText } from '../../themes/themes';
import { useTheme, useThemeStyles } from '../../utils/hooks';
import { singleOrArrayToArray } from '../../utils/utils';
import { comboBoxStylesDefault } from './ComboBox.styles';
export interface IComboBoxProps
  extends Omit<FIComboBoxProps, 'styles' | 'buttonIconProps' | 'caretDownButtonStyles'>,
    IComponent<Partial<IComboBoxStyles>> {
  iconStyles?: IStyleFunctionOrObject<IIconStyles> | IStyleFunctionOrObject<IIconStyles>[];
  emptyMessage?: string;
  onInputValueChange?: (text: string) => void;
}

export const ComboBox = forwardRef((props: IComboBoxProps, ref: Ref<HTMLDivElement>) => {
  const {
    styles,
    iconStyles,
    allowFreeform = true,
    autoComplete = 'off',
    emptyMessage = 'None available',
    ..._fProps
  } = props;
  const { disabled, options, placeholder } = props;
  const theme = useTheme();
  const fProps: FIComboBoxProps = {
    ..._fProps,
    allowFreeform,
    autoComplete,
    // override
    styles: useThemeStyles<Partial<IComboBoxStyles>>(comboBoxStylesDefault, styles),
    buttonIconProps: {
      iconName: IconName.ChevronDown,
      styles: useThemeStyles<Partial<IIconStyles>>(undefined, [
        ...singleOrArrayToArray(iconStyles),
        iconStylesCaretDown,
        iconStylesDarkText,
      ]),
    },
    caretDownButtonStyles: {
      root: {
        borderRadius: 0,
      },
    },
    comboBoxOptionStyles: {
      root: {
        minHeight: Sizes.height,
        padding: `0 ${Sizes.padding}px`,
        '&:hover': {
          color: theme.semanticColors?.inputReadOnlyText,
          backgroundColor: theme.semanticColors?.inputListItemHoveredBackground,
          '.ms-Checkbox-checkbox': {
            backgroundColor: theme.semanticColors?.inputListItemActiveBackground,
          },
        },
        '&.is-checked': {
          backgroundColor: theme.semanticColors?.inputListItemActiveBackground,
        },
        '&.is-checked .ms-Checkbox-label .ms-Checkbox-checkbox': {
          backgroundColor: theme.palette?.primary300,
        },
      },
    },
    disabled: disabled ? disabled : options && options.length === 0 ? true : disabled,
    placeholder: options && options.length === 0 ? emptyMessage : placeholder,
  };
  return <FComboBox {...fProps} ref={ref} data-test={props['data-test'] || 'combobox'} />;
});
